<template>
  <div class="noData_empty">
    <img src="@/assets/empty.png" alt />
    <span>暂无数据</span>
  </div>
</template>

<script>
export default {
  name: 'noData'
}
</script>

<style lang="scss" scoped>
.noData_empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0;
  padding: 20px;
  min-height: 300px;
  img {
    width: 70px;
    height: 70px;
    margin-bottom: 6px;
  }
  span {
    font-size: 14px;
    color: #999;
    line-height: 14px;
  }
}
</style>
